export const interval: number = 1000



// WEBPACK FOOTER //
// ./src/constants/interval.ts